import { useState } from "react";
import { cn } from "@rekati/utils";

/**
 * A logo from `GET /v1/brand` (docs/api.md 40.2). A URL is "" until the logo
 * is stored, and an image can fail to load: both fall back to `fallbackSrc`
 * (an app's bundled copy of the same logo) and then to the name as text, so
 * the brand is never a broken image.
 */
export function BrandLogo({
  src,
  fallbackSrc,
  name,
  className,
  textClassName,
}: {
  src: string | null | undefined;
  fallbackSrc?: string;
  name: string;
  className?: string;
  textClassName?: string;
}) {
  const [failed, setFailed] = useState<string[]>([]);
  const url = [src, fallbackSrc].find((u): u is string => Boolean(u) && !failed.includes(u as string));
  if (!url) {
    return name ? <span className={cn("font-semibold tracking-tight", textClassName)}>{name}</span> : null;
  }
  return (
    <img
      src={url}
      alt={name}
      className={cn("h-7 w-auto object-contain", className)}
      onError={() => setFailed((f) => [...f, url])}
      decoding="async"
    />
  );
}
